import React from 'react';
import { useHistory } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './desktop-recommend-product-thumbnail-style.scss';

import { Loading } from '@atoms';
import MgsIcon from '@src/images/icons/mgs-logo.png';
import { MgsLogoIcon } from '@components/ProductPage/ProductDetailSummary';
import Typography from '@src/componentsNew/Typography/Typography';

import { recommendedProducts_product_recommendedProducts } from '@src/components/ProductPage/ProductDetailRecommendation/__generated__/recommendedProducts';

import { gaV4SearchProductDetail, gaV4ClickRecommendedProduct, getDBIdFromGraphqlId } from '@utils';
import { isNew, getPriceInfoFromProduct, formatPrice } from '@src/utils';

interface IProps {
  product: recommendedProducts_product_recommendedProducts;
  productId: string;
  index: number;
  recommendType: string;
}

const DesktopRecommendProductThumbnail = ({ product, productId, index, recommendType }: IProps) => {
  const history = useHistory();

  const { originalPrice, finalPrice, discountPercent, isOnSale } = getPriceInfoFromProduct(product);

  const isIncludeSearchUrl = (product) => {
    const handleOnDetailSearchEvent = async (productId, productName, brandId, brandName, keyword, searchText) => {
      await gaV4SearchProductDetail(productId, productName, brandId, brandName, keyword, searchText);
    };

    const currentLocation = history.location;

    if (currentLocation.search.includes('?refer=search')) {
      const urlParams = new URLSearchParams(currentLocation.search);
      const keyword = urlParams.get('word');
      const searchText = urlParams.get('text');

      handleOnDetailSearchEvent(
        getDBIdFromGraphqlId(product.id, 'Product'),
        product.name,
        getDBIdFromGraphqlId(product.brandLink.id, 'Brand'),
        product.brand,
        keyword ? keyword : '',
        searchText ? searchText : '',
      );
    } else if (currentLocation.pathname.includes('/search-result')) {
      const urlParams = new URLSearchParams(currentLocation.search);
      const keyword = urlParams.get('q');
      const searchText = urlParams.get('q');

      handleOnDetailSearchEvent(
        getDBIdFromGraphqlId(product.id, 'Product'),
        product.name,
        getDBIdFromGraphqlId(product.brandLink.id, 'Brand'),
        product.brand,
        keyword ? keyword : '',
        searchText ? searchText : '',
      );
    }
  };

  const handleClickThumbnail = (product) => {
    gaV4ClickRecommendedProduct(
      getDBIdFromGraphqlId(productId).toString(),
      getDBIdFromGraphqlId(productId).toString(),
      index,
      recommendType,
    );
    isIncludeSearchUrl(product);
    history.push(product.urlForGraphql);
  };

  return (
    (product && (
      <div className="desktop-recommend-product-thumbnail-wrapper" onClick={() => handleClickThumbnail(product)}>
        <div className="product-image-wrapper">
          <LazyLoadImage className="product-image" src={product.thumbnail.url} alt={product.name} effect="blur" />
        </div>

        <div className="product-description-wrapper">
          <Typography cName="brand-name" variant="subtitle2" component="span" style={{ color: '#090A0FDE' }}>
            {product.brand}
          </Typography>

          <div className="product-name">
            {isNew(product.publicationDate) ? (
              <Typography variant="subtitle2" component="span" style={{ color: '#FF3399' }}>
                {`New `}
              </Typography>
            ) : null}

            <Typography variant="body3" component="span" style={{ color: '#666666' }}>
              {product.name}
            </Typography>
          </div>

          {product.productType.isMgs && <MgsLogoIcon src={MgsIcon} style={{ width: '4rem' }} />}

          <div className="final-price-wrapper">
            <Typography variant="price" component="span" style={{ color: '#090A0FDE' }}>
              {formatPrice(finalPrice)}
            </Typography>
            {isOnSale && (
              <>
                <Typography variant="price" component="span" style={{ color: '#FF3399' }}>
                  {discountPercent}%
                </Typography>
                <Typography variant="strikethrough2" component="span" style={{ color: '#11141D61' }}>
                  {formatPrice(originalPrice)}
                </Typography>
              </>
            )}
          </div>
        </div>
      </div>
    )) || <Loading />
  );
};

export default DesktopRecommendProductThumbnail;
